export enum PictureFormat {
  PNG = 'png',
  WEBP = 'webp',
  JPEG = 'jpeg',
  JPG = 'jpg',
  GIF = 'gif',
  AVIF = 'avif',
  SVG = 'svg',
}

export enum PictureFit {
  Fill = 'fill',
  Contain = 'contain',
  Cover = 'cover',
  None = 'none',
  ScaleDown = 'scale-down',
}
